import classNames from "classnames";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { AvailabilityRule } from "PFTypes";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import css from "./readable_ranges_wrapper.module.scss";

type ReadableRangesWrapperProps = {
  availability: AvailabilityRule;
  showEllipsis: boolean;
};

export const ReadableRangesWrapper = ({
  availability,
  showEllipsis,
  children
}: PropsWithChildren<ReadableRangesWrapperProps>) => {
  const { t } = useTranslation();

  return (
    <div>
      <Stack gap="spacingSm" className={classNames({ [css.paddingBottom]: !showEllipsis })}>
        <Stack gap="spacingLg">{children}</Stack>
        {showEllipsis && <Typography variant="bodyRegular">...</Typography>}
      </Stack>
      {!showEllipsis && (
        <Typography variant="bodyRegular" tag="span">
          {t("availabilityRequirement.matchingAtLeast", {
            percentage: getAttribute(availability, "availability_threshold")
          })}
        </Typography>
      )}
    </div>
  );
};
